"use client";

import React from "react";
import { Instagram, Facebook, Music } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const socialLinks = [{
  id: 1,
  name: "Instagram",
  url: "https://www.instagram.com/loraserramenti?igsh=MTg1NDZ0bXpzcWM5dQ%3D%3D&utm_source=qr"
}, {
  id: 2,
  name: "TikTok",
  url: "https://www.tiktok.com/@loraserramenti?_r=1&_t=ZN-94YBeMMiRza"
}, {
  id: 3,
  name: "Facebook",
  url: "https://www.facebook.com/share/1GVNCsA9EE/?mibextid=LQQJ4d"
}];
export default function FollowUsOnInstagram() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="seguici-su-instagram" className="relative py-24 w-full overflow-hidden bg-[#576192] bg-[radial-gradient(circle_at_0%_0%,rgba(255,255,255,0.15)_0%,transparent_50%),radial-gradient(circle_at_100%_100%,rgba(0,0,0,0.1)_0%,transparent_50%)]">
      <div ref={ref} className={cn("max-w-7xl mx-auto px-6 flex flex-col items-center text-center transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 tracking-tight">
          Seguici sui nostri social
        </h2>
        <p className="text-lg text-white font-normal max-w-2xl mb-10 leading-relaxed">
          Scopri il dietro le quinte dei nostri progetti, dalle fasi di installazione ai dettagli di design che rendono uniche le nostre realizzazioni. Condividiamo ogni giorno la passione e la precisione che mettiamo nel trasformare i vostri spazi.
        </p>
        
        <div className="flex items-center gap-6">
          {socialLinks.map((social, i) => <Link key={social.id} to={social.url} newTab data-index={i} className="flex items-center justify-center w-14 h-14 rounded-full bg-background border border-border text-primary hover:bg-primary hover:text-primary-foreground hover:scale-110 shadow-sm transition-all duration-300" aria-label={`Seguici su ${social.name}`}>
              {social.name === "Instagram" && <Instagram className="w-6 h-6" />}
              {social.name === "TikTok" && <Music className="w-6 h-6" />}
              {social.name === "Facebook" && <Facebook className="w-6 h-6" />}
            </Link>)}
        </div>
      </div>
    </section>;
}